import { Button, Kind } from '@thanx/uikit/button'
import { Radio, RadioGroup } from '@thanx/uikit/radio'
import { Text } from '@thanx/uikit/text'
import EditNavbar from 'components/Navbar/EditNavbar'
import PopoverInfo from 'components/PopoverInfo'
import Section from 'components/Section'
import { buildTranslate } from 'locales'
import { TimeBasedMenuVisibilitySetting } from 'models/Config'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'

const t = buildTranslate('cms.settings.time_based_menu_visibility')

function parseSetting(
  value: unknown
): TimeBasedMenuVisibilitySetting | undefined {
  return Object.values(TimeBasedMenuVisibilitySetting).find(
    setting => setting === value
  )
}

type Props = {
  setting?: TimeBasedMenuVisibilitySetting
  isSubmitting: boolean
  onPublish: (setting: TimeBasedMenuVisibilitySetting) => void
  onExit: () => void
}

const TimeBasedMenuVisibilityEdit = ({
  setting,
  isSubmitting,
  onPublish,
  onExit,
}: Props) => {
  const [editSetting, setEditSetting] = useState(setting)

  return (
    <div className="h-100">
      {ReactDOM.createPortal(
        <EditNavbar
          title={
            <div>
              <Text.SmallCaps3 tag="div" color="white" className="mb-xxs">
                {t('configuration')}
              </Text.SmallCaps3>
              <Text.Header4 className="my-0" color="white">
                {t('title')}
              </Text.Header4>
            </div>
          }
        >
          <div>
            <Button
              kind={Kind.SECONDARY_REVERSE}
              className="mr-s"
              onClick={onExit}
            >
              {t('exit_without_saving')}
            </Button>
            <Button
              kind={Kind.PRIMARY_REVERSE}
              onClick={() => editSetting && onPublish(editSetting)}
              disabled={isSubmitting || !editSetting}
            >
              {t('publish_changes')}
            </Button>
          </div>
        </EditNavbar>,
        document.body
      )}
      <Section className="p-m">
        <div className="mb-m">
          <span className="bold font-size-14">{t('field_label')}</span>
          <PopoverInfo className="ml-xs" text={t('description')} />
        </div>
        <RadioGroup
          aria-label={t('options_label')}
          value={editSetting}
          onChange={value => setEditSetting(parseSetting(value))}
        >
          <div className="mb-m">
            <Radio
              value={TimeBasedMenuVisibilitySetting.VISIBLE}
              checked={editSetting === TimeBasedMenuVisibilitySetting.VISIBLE}
            >
              {t('options.visible')}
            </Radio>
            <p className="body-text-4 grey-70 ml-l mt-xxs">
              {t('options.visible_explanation')}
            </p>
          </div>
          <div>
            <Radio
              value={TimeBasedMenuVisibilitySetting.HIDDEN}
              checked={editSetting === TimeBasedMenuVisibilitySetting.HIDDEN}
            >
              {t('options.hidden')}
            </Radio>
            <p className="body-text-4 grey-70 ml-l mt-xxs">
              {t('options.hidden_explanation')}
            </p>
          </div>
        </RadioGroup>
      </Section>
    </div>
  )
}

export default TimeBasedMenuVisibilityEdit
